'use strict';

(function () {
  if (customElements.get('journey-slider')) return;

  class JourneySlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initSwiper() {
      const sliderEl = this.querySelector('.swiper');
      if (!sliderEl) return;

      const {
        autoplay,
        speed,
        changeSpeed,
        spaceBetween = 16,
        spaceBetweenPc = 16,
        loop
      } = this.dataset;

      const slideSpeed = Number(speed) > 0 ? Number(speed) : 400;
      const spaceMb = Number(spaceBetween) || 16;
      const spacePc = Number(spaceBetweenPc) || 16;
      const isLoop = loop === 'true';

      // ✅ Ambil tombol yang bener (prioritaskan one-slide-per-page)
      const nextBtn =
        this.querySelector('.one-slide-per-page.swiper-button-next') ||
        this.querySelector('.title-wrapper .swiper-button-next');

      const prevBtn =
        this.querySelector('.one-slide-per-page.swiper-button-prev') ||
        this.querySelector('.title-wrapper .swiper-button-prev');

      const scrollbarEl = this.querySelector('.swiper-scrollbar');

      const params = {
        speed: slideSpeed,
        slidesPerView: 'auto',
        spaceBetween: spaceMb,

        loop: isLoop,
        loopAdditionalSlides: 4,
        watchSlidesProgress: true,

        // ✅ biar "scroll feel" sama kayak non-loop
        freeMode: false,

        scrollbar: scrollbarEl
          ? { el: scrollbarEl, draggable: true }
          : undefined,

        navigation: nextBtn && prevBtn
          ? { nextEl: nextBtn, prevEl: prevBtn }
          : undefined,

        breakpoints: {
          750: { spaceBetween: spacePc }
        }
      };

      if (autoplay === 'true') {
        params.autoplay = {
          delay: Number(changeSpeed) || 4000,
          disableOnInteraction: false
        };
      }

      this.swiper = new Swiper(sliderEl, params);

      // ✅ Kalau loop ON, pastikan tombol gak pernah disabled (biar gak “error mentok”)
      if (isLoop && nextBtn && prevBtn) {
        nextBtn.classList.remove('disabled');
        prevBtn.classList.remove('disabled');
      }
    }
  }

  customElements.define('journey-slider', JourneySlider);
})();
